export const FETCH_LOCALE = 'FETCH_LOCALE';
export const SWITCH_LOCALE = 'SWITCH_LOCALE';
